import React, { useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const images = ['https://cdn.magicpatterns.com/uploads/2Kjyui1n3kxPi2MsNJmEof/image.png', 'https://cdn.magicpatterns.com/uploads/o5M6b3bUCTmo73TFrHEfWS/image.png', 'https://cdn.magicpatterns.com/uploads/t9NupbkYf3TRE7oKLpqdVu/image.png', 'https://cdn.magicpatterns.com/uploads/3uhysqujCCMu9VuC64mjXZ/image.png', 'https://cdn.magicpatterns.com/uploads/22C7dR1MFNbTeeKFSDeCyF/image.png'];
const variants = {
  enter: (direction: number) => ({
    x: direction > 0 ? '100%' : '-100%',
    opacity: 0
  }),
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: (direction: number) => ({
    zIndex: 0,
    x: direction < 0 ? '100%' : '-100%',
    opacity: 0
  })
};
export function PreviewGallerySection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const nextImage = () => {
    setDirection(1);
    setCurrentIndex(prev => prev === images.length - 1 ? 0 : prev + 1);
  };
  const prevImage = () => {
    setDirection(-1);
    setCurrentIndex(prev => prev === 0 ? images.length - 1 : prev - 1);
  };
  const goToImage = (index: number) => {
    setDirection(index > currentIndex ? 1 : -1);
    setCurrentIndex(index);
  };
  return <section className="py-10 md:py-14 px-4 bg-white" data-id="element-58">
      <div className="max-w-6xl mx-auto" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-8" data-id="element-60">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#2D2D3F]" data-id="element-61">
            Así se ven algunas páginas del pack
          </h2>
        </motion.div>

        <div className="max-w-2xl mx-auto mb-8" data-id="element-62">
          {/* Carousel Container */}
          <div className="relative w-full aspect-[3/4] sm:aspect-[4/5] bg-[#FFFAF7] rounded-2xl shadow-lg overflow-hidden border border-gray-100 flex items-center justify-center" data-id="element-63">
            <AnimatePresence initial={false} custom={direction} data-id="element-64">
              <motion.img key={currentIndex} src={images[currentIndex]} alt={`Preview ${currentIndex + 1}`} width="600" height="800" loading="lazy" decoding="async" custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
              x: {
                type: 'spring',
                stiffness: 300,
                damping: 30
              },
              opacity: {
                duration: 0.2
              }
            }} className="absolute w-full h-full object-contain p-4 sm:p-8" data-id="element-65" />
            </AnimatePresence>

            {/* Left Arrow */}
            <button onClick={prevImage} className="absolute left-2 sm:left-4 z-10 w-8 h-8 sm:w-10 sm:h-10 bg-white rounded-full shadow-md flex items-center justify-center text-[#2D2D3F] hover:text-[#FF6B8A] transition-colors focus:outline-none focus:ring-2 focus:ring-[#FF6B8A]" aria-label="Imagen anterior" data-id="element-66">
              <ChevronLeftIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-67" />
            </button>

            {/* Right Arrow */}
            <button onClick={nextImage} className="absolute right-2 sm:right-4 z-10 w-8 h-8 sm:w-10 sm:h-10 bg-white rounded-full shadow-md flex items-center justify-center text-[#2D2D3F] hover:text-[#FF6B8A] transition-colors focus:outline-none focus:ring-2 focus:ring-[#FF6B8A]" aria-label="Siguiente imagen" data-id="element-68">
              <ChevronRightIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-69" />
            </button>
          </div>

          {/* Dot Indicators */}
          <div className="flex justify-center items-center space-x-2 mt-6" data-id="element-70">
            {images.map((_, index) => <button key={index} onClick={() => goToImage(index)} className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full transition-colors focus:outline-none ${index === currentIndex ? 'bg-[#FF6B8A]' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Ir a la imagen ${index + 1}`} data-id="element-71" />)}
          </div>
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.3
      }} className="text-center text-base sm:text-lg font-bold text-[#FF6B8A]" data-id="element-72">
          Elegí tu favorita, imprimila y empezá a colorear en minutos.
        </motion.p>
      </div>
    </section>;
}